module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "calibre9",
    attrs: {
      "id": "pgepubid00001"
    }
  }, [_vm._v("\nTABLE OF CONTENTS\n")]), _vm._v(" "), _c('h4', {
    staticClass: "calibre10 sigil_not_in_toc",
    attrs: {
      "id": "pgepubid00002"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Section0003"
    }
  }, [_vm._v("The Descent of Man")]), _vm._v(" "), _c('br', {
    staticClass: "calibre5"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/Section0004"
    }
  }, [_vm._v("The Other Two")]), _vm._v(" "), _c('br', {
    staticClass: "calibre5"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Expiation")]), _vm._v(" "), _c('br', {
    staticClass: "calibre5"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Lady's Maid's Bell")]), _vm._v(" "), _c('br', {
    staticClass: "calibre5"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Mission of Jane")]), _vm._v(" "), _c('br', {
    staticClass: "calibre5"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Reckoning")]), _vm._v(" "), _c('br', {
    staticClass: "calibre5"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Letter")]), _vm._v(" "), _c('br', {
    staticClass: "calibre5"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Dilettante")]), _vm._v(" "), _c('br', {
    staticClass: "calibre5"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Quicksand")]), _vm._v(" "), _c('br', {
    staticClass: "calibre5"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Venetian Night's Entertainment")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a637da12","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0002.vue
// module id = 60
// module chunks = 0